import { isFeatureEnabled } from '@sdk/utils/isFeatureEnabled';

import config from '@angular/config';

class AutomatedBreaksService {
  constructor(Authentication) {
    'ngInject';

    Object.assign(this, { Authentication });
    this.AUTOMATED_BREAKS_ENABLED = isFeatureEnabled(
      config.AUTOMATED_BREAKS_ENABLED,
      Authentication.user.org.id
    );
  }

  get areAutomatedBreaksOn() {
    return Boolean(
      this.AUTOMATED_BREAKS_ENABLED &&
        this.Authentication.user.orgSettings.shiftBreakType &&
        this.Authentication.user.orgSettings.automatedBreaksIsEnabled
    );
  }
}

export default AutomatedBreaksService;
